import { FormActivity, FormActivityModel } from '.';
import {
  DataEntity,
  FreeFormTextDataEntity,
  DateDataEntity,
  ListDataEntity,
  ControlType
} from '../data-entities';
import { Utilities } from '../../services';

export class ContractorRegistrationDecisionActivity extends FormActivity {
  hideExpirationDate: boolean;
  showHideExpirationDateOption: boolean;
  allowApplicantAsRole: boolean;

  constructor(options?: Partial<ContractorRegistrationDecisionActivity>) {
    super(options);

    this.type = 'contractor-registration-decision-activity';
    this.name = 'Contractor Registration Decision Activity';
    this.description =
      'Use this activity to make a decision on contractor registrations.';

    if (options) {
      Object.assign(this, options);
    }

    this.model = new FormActivityModel(options ? options.model : null);

    this.model.screenName =
      this.model.screenName || 'Contractor Registration Decision';
  }
}
